import { createElement } from 'react';

import { cn } from '@/lib/utils';
import { FIELD_TYPE_META } from '@/features/module-builder/constants';
import type { ModuleFieldType } from '@/features/module-builder/types';

export interface FieldTypeIconProps {
    fieldType: ModuleFieldType;
    className?: string;
    /** Drop the per-type colour — for dense forms, where a rainbow of glyphs is noise. */
    muted?: boolean;
}

/**
 * The field-type glyph (colored per FIELD_TYPE_META) shown next to field
 * labels across the quick view, record page, and form surfaces.
 */
export function FieldTypeIcon({ fieldType, className, muted = false }: FieldTypeIconProps) {
    const meta = FIELD_TYPE_META[fieldType];
    if (!meta) return null;
    return createElement(meta.icon, {
        className: cn('size-3.5 shrink-0', muted && 'text-text-tertiary', className),
        style: muted ? undefined : { color: meta.color },
        'aria-hidden': true,
    });
}
